import { Select, Spin } from "antd";
import React, { useCallback, useState } from "react";
import { apiContract } from "../../../../api/api-contract";

const { Option } = Select;

const BienKSXe = ({ setFieldsValue, name, type }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchUser = (value) => {
    setLoading(true);
    apiContract
      .vehiclesSuggest(value)
      .then((res) => {
        if (res.status === "success") {
          setOptions(
            res.data.content.map((i) => ({
              value: i.id,
              label: i.number_plate,
            }))
          );
        }
      })
      .finally(() => setLoading(false));
  };

  const onChange = useCallback(
    (values) => {
      if (type === "TicketFee") {
        !!setFieldsValue &&
          setFieldsValue({
            [name]: values.length > 0 ? values.map((i) => i.value) : null,
          });
      } else {
        !!setFieldsValue &&
          setFieldsValue({
            [name]: {
              id_in: values.length > 0 ? values.map((i) => i.value) : null,
            },
          });
      }
    },
    [setFieldsValue, name, type]
  );

  return (
    <Select
      mode="multiple"
      showArrow
      placeholder="Biển KS xe"
      labelInValue
      notFoundContent={loading ? <Spin size="small" /> : null}
      filterOption={false}
      onChange={onChange}
      onSearch={fetchUser}
    >
      {options.map((item, index) => (
        <Option
          key={index}
          value={type === "TicketFee" ? item.label : item.value}
        >
          {item.label}
        </Option>
      ))}
    </Select>
  );
};

export default BienKSXe;
